import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { RenderForm } from "@components/Forms/Render";
import { Awesome } from "@components/Helpers";
import { CommonCard, ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function CounterpartyDocs(props) {
    const params = useParams();
    return params.id ? <Add {...props} /> : <List {...props} />;
}

function List({ developerId, header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:developer:counterparty_docs", { developer_id: developerId }));
    if (!apiData) return;

    const headerTools = (
        <Link to={url_reverse("devs:counterparty_docs:add", { dev_id: developerId })} className="btn btn-sm btn-dark">
            <Awesome type="plus-circle" /> {t("Добавить")}
        </Link>
    );

    return (
        <ListingCard header={header} headerTools={headerTools}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>{t("Файл")}</th>
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((obj) => (
                        <tr key={`object_list${obj.id}`}>
                            <td>
                                <a href={obj.file} target="_blank">
                                    {obj.filename}
                                </a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </ListingCard>
    );
}

function Add({ developerId, header }) {
    const { apiData } = useAppApi(url_reverse("api:developer:counterparty_docs:add", { developer_id: developerId }));
    if (!apiData) return;

    return (
        <CommonCard header={header}>
            <RenderForm backUrl={url_reverse("devs:counterparty_docs", { dev_id: developerId })} />
        </CommonCard>
    );
}
